export const LOAD_WORKERS = "LOAD_WORKERS"
export const loadWorkersAction = workers => ({
   type: LOAD_WORKERS,
   payload: workers
})